import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AutenticadoGuard } from './guards/autenticado.guard';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';


const routes: Routes = [
    {
        path: '',
        loadChildren: './pages/home/home.module#HomePageModule',
        pathMatch: 'full'
    },
    {
        path: 'login',
        loadChildren: './pages/login/login.module#LoginPageModule'
    },
    {
        path: 'painel',
        loadChildren: './pages/painel-geral/painel-geral.module#PainelGeralPageModule',
        canActivate: [AutenticadoGuard]
    },
    {
        path: 'estabelecimentos/analise',
        loadChildren: './pages/estabelecimentos/lista-analise/lista-analise.module#ListaAnaliseEstabelecimentosPageModule',
        canActivate: [AutenticadoGuard]
    },
    {
        path: 'estabelecimentos/rascunhos',
        loadChildren: './pages/estabelecimentos/rascunhos/rascunhos-estabelecimento.module#RascunhosEstabelecimentoPageModule',
        canActivate: [AutenticadoGuard]
    },
    // {
    //     path: 'estabelecimentos/entidades',
    //     loadChildren: './pages/estabelecimentos/entidades/entidades-estabelecimento.module#EntidadesEstabelecimentoPageModule',
    //     canActivate: [AutenticadoGuard]
    // },
    // {
    //     path: 'estabelecimentos/entidades/cadastro',
    //     // tslint:disable-next-line:max-line-length
    //     loadChildren: './pages/estabelecimentos/entidades/form-entidade/form-entidade-estabelecimento.module#FormEntidadeEstabelecimentoPageModule',
    //     canActivate: [AutenticadoGuard]
    // },
    {
        path: 'rascunho-estabelecimento',
        loadChildren: './pages/estabelecimentos/edicao/edicao-estabelecimento.module#EdicaoEstabelecimentoPageModule',
        canActivate: [AutenticadoGuard]
    },
    {
        path: 'estabelecimentos/painel/:idEstabelecimento',
        loadChildren: './pages/estabelecimentos/painel-estabelecimento/painel-estabelecimento.module#PainelEstabelecimentoPageModule',
        canActivate: [AutenticadoGuard]
    },
    {
        path: 'estabelecimentos/analise/:idEstabelecimento',
        loadChildren: './pages/estabelecimentos/analise-estabelecimento/analise-estabelecimento.module#AnaliseEstabelecimentoPageModule',
        canActivate: [AutenticadoGuard]
    },
    {
        path: 'notificacoes',
        loadChildren: './pages/notificacoes/notificacoes.module#NotificacoesModule',
        canActivate: [AutenticadoGuard]
    },
    {
        path: 'gestor',
        loadChildren: './pages/gestor/gestor.module#GestorPageModule',
        canActivate: [AutenticadoGuard]
    },
    {
        path: 'estabelecimentos/manter',
        loadChildren: './pages/estabelecimentos/manter/manter.module#ManterPageModule',
        canActivate: [AutenticadoGuard]
    },
    {
        path: 'estabelecimentos/manter/:id',
        loadChildren: './pages/estabelecimentos/manter/manter.module#ManterPageModule',
        canActivate: [AutenticadoGuard]
    },
    {
        path: '**',
        component: PageNotFoundComponent
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
